export default Object.freeze({
  APPROVED: "approved",
  DENIED: "denied",
});
